var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMemberspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "user_1_",
    "data-name": "user (1)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: -38.449,
    x2: 1,
    y2: -38.449,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00f38d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009eff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15270",
    "data-name": "Path 15270",
    d: "M49,24.5A24.5,24.5,0,1,1,24.5,0,24.5,24.5,0,0,1,49,24.5Zm0,0",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15271",
    "data-name": "Path 15271",
    d: "M111.369,90.194a9.278,9.278,0,1,0-11.14,0A15.922,15.922,0,0,0,89.9,105.082h2.871a13.025,13.025,0,0,1,26.05,0h2.871A15.923,15.923,0,0,0,111.369,90.194ZM99.391,82.778a6.407,6.407,0,1,1,6.407,6.408A6.414,6.414,0,0,1,99.391,82.778Zm0,0",
    transform: "translate(-81.298 -66.466)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMemberspace);
export default __webpack_public_path__ + "static/media/icon-memberspace.8043a054.svg";
export { ForwardRef as ReactComponent };